<template>
  <div>

    <v-toolbar color="appMenu" dense dark >
       <v-toolbar-title> <v-icon left > mdi-account </v-icon>My Profile</v-toolbar-title>
         <v-spacer></v-spacer>
    </v-toolbar>
 <v-container fluid>

    
      <v-row>
        <v-col cols="12">
      
            <UserProfile />      
        </v-col>
      </v-row>         
 
 </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
// import OverviewChart from "@/components/OverviewChart.vue";
import UserProfile from "@/components/UserProfile.vue";
export default {
  name: "MyProfile",
  components: {
    // OverviewChart,
    UserProfile,
  },
};
</script>
